import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { makeStyles } from "@material-ui/core/styles";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles({
  paper: {
    fontSize: '12px !important',    
  }
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const classes = useStyles();
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [savingBtn, setSavingBtn] = React.useState(false);

  const [homeDisplay, setHomeDisplay] = React.useState(true);
  const [publicDisplay, setPublicDisplay] = React.useState(true);
  const [headerDisplay, setHeaderDisplay] = React.useState(false);
  const [footerDisplay, setFooterDisplay] = React.useState(false);
  const [sideDisplay, setSideDisplay] = React.useState(false);
  const [categoryName, setCategoryName] = React.useState("");
  const [categoryUrl, setCategoryUrl] = React.useState("");
  const [parentCategoryId, setParentCategoryId] = React.useState(0);
  const [parentCategoryName, setParentCategoryName] = React.useState("");
  const [channelId, setChannelId] = React.useState(0);
  const [channelName, setChannelName] = React.useState("");
  const [seoTitle, setSeoTitle] = React.useState("");
  const [seoDescription, setSeoDescription] = React.useState("");
  const [seoKeywords, setSeoKeywords] = React.useState("");
  const [seoTags, setSeoTags] = React.useState("");

  const [categoryList, setCategoryList] = React.useState([]);
  ///const [channelList, setChannelList] = React.useState([]);

  

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  const handlePublicDisplay = (event) => {
    setPublicDisplay(event.target.checked);
  };

  const handleHomeDisplay = (event) => {
    setHomeDisplay(event.target.checked);
  };

  const handleHeaderDisplay = (event) => {
    setHeaderDisplay(event.target.checked);
  };

  const handleFooterDisplay = (event) => {
    setFooterDisplay(event.target.checked);
  };

  const handleSideDisplay = (event) => {
    setSideDisplay(event.target.checked);
  };

  React.useEffect(() => {	
    setSavingBtn(false);

    if(open && props.dataObj && props.dataObj.autoId>0){
      setCategoryName(props.dataObj.categoryName);
      setCategoryUrl(props.dataObj.categoryUrl);

      if(props.dataObj.parentId){
        setParentCategoryId(props.dataObj.parentId);        
      }else{
        setParentCategoryId(0);
      }
      setParentCategoryName(props.dataObj.parentCategoryName);
      
      if(props.dataObj.channelId && props.dataObj.channelId>0){
        setChannelId(props.dataObj.channelId);
        getApiDataCategoryList(props.dataObj.channelId);
      }else{
        setChannelId(0);
      }
      setChannelName(props.dataObj.channelName);
      setSeoTitle(props.dataObj.seoTitle);
      setSeoDescription(props.dataObj.seoDescription);
      setSeoKeywords(props.dataObj.seoKeywords);
      setSeoTags(props.dataObj.seoTags);

      if(props.dataObj.publicDisplay===1){
        setPublicDisplay(true);
      }else{
        setPublicDisplay(false);
      }

      if(props.dataObj.homeDisplay===1){
        setHomeDisplay(true);
      }else{
        setHomeDisplay(false);
      }

      if(props.dataObj.headerDisplay===1){
        setHeaderDisplay(true);
      }else{
        setHeaderDisplay(false);
      }

      if(props.dataObj.footerDisplay===1){
        setFooterDisplay(true);
      }else{
        setFooterDisplay(false);
      }

      if(props.dataObj.sideDisplay===1){
        setSideDisplay(true);
      }else{
        setSideDisplay(false);
      }
     

    }else{
      setCategoryName("");
      setCategoryUrl("");
      setParentCategoryId(0);
      setParentCategoryName("");
      setChannelId(0);
      setChannelName("");
      setSeoTitle("");
      setSeoDescription("");
      setSeoKeywords("");
      setSeoTags("");
      setPublicDisplay(true);
      setHomeDisplay(true);
      setHeaderDisplay(false);
      setFooterDisplay(false);
      setSideDisplay(false);
                
    }
	}, [open,props.dataObj]);

  

  async function getApiDataCategoryList(chanlId){
      let axiosHeader = {
        headers:{
          'Content-Type': 'multipart/mixed',
          'loginId': userObj.obj.loginId,
          'token': userObj.obj.token,
          'device': 'web'
        }
      }; 
			axios.get(env.API_URL+'/admin/category-list?channelId='+chanlId, axiosHeader)
			   .then(response => {
				 if(response.data && response.data.responseTxt==="InvalidToken"){ 
					  window.location.href='login';
				 }else if(response.data.responseTxt==="success"){
            setCategoryList(response.data?.obj);
				 }	 				
			})
	}


	function saveData(){  
    setSavingBtn(true);  
    if(!categoryName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter category name");			
      return false;
    }  
    if(!categoryUrl){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter category URL");			
      return false;
    }  

		if(categoryName && categoryName.length>1 && categoryUrl && categoryUrl.length>1){ 
			let axiosHeader = {
				headers:{
				  'Content-Type': 'multipart/mixed',
				  'loginId': userObj.obj.loginId,
				  'token': userObj.obj.token,
				  'device': 'web'
				}
			};
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId>0){
        data.append('id', props.dataObj.autoId);
      }
      data.append('categoryName', categoryName);
      data.append('categoryUrl', categoryUrl);
      data.append('parentId', parentCategoryId);
      data.append('parentCategoryName', parentCategoryName);
      data.append('channelId', channelId);
      data.append('channelName', channelName);
      data.append('seoTitle', seoTitle);
      data.append('seoDescription', seoDescription);
      data.append('seoKeywords', seoKeywords);
      data.append('seoTags', seoTags);
    
      if(publicDisplay===true){
        data.append('publicDisplay', 1);
      }else{
        data.append('publicDisplay', 0);
      }

      if(homeDisplay===true){
        data.append('homeDisplay', 1);
      }else{
        data.append('homeDisplay', 0);
      }

      if(headerDisplay===true){
        data.append('headerDisplay', 1);
      }else{
        data.append('headerDisplay', 0);
      }

      if(footerDisplay===true){
        data.append('footerDisplay', 1);
      }else{
        data.append('footerDisplay', 0);
      }

      if(sideDisplay===true){
        data.append('sideDisplay', 1);
      }else{
        data.append('sideDisplay', 0);
      }

      let apiURL='/admin/category-create';
      let myMessage="Category has been created.";
      if(props.dataObj && props.dataObj.autoId>0){
          apiURL='/admin/category-update';
          myMessage="Category has been updated.";
      }
             
			axios.post(env.API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSavingBtn(false);
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage(myMessage);
          window.location.reload();	
					return false;
        }else if(response.data.responseTxt==="AlreadyExistsError"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("This category was created earlier. Kindly enter another category");
            return false;  					
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This category could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})	
		}		
	}

  

  const handleChannel = (val) => {
    if(val){
      let varArr = val.split('$');
      setChannelId(varArr[0]);
      setChannelName(varArr[1]);
      if(open && userObj.obj.loginId){
          getApiDataCategoryList(varArr[0]);
          setParentCategoryId(0);
          setParentCategoryName("");
      }
    }else{
      setChannelId(0);
      setChannelName("");
    }
  }

  const handleParentCategory = (val) => {
      if(val){
        let varArr = val.split('$');
        setParentCategoryId(varArr[0]);
        setParentCategoryName(varArr[1]);
      }else{
        setParentCategoryId(0);
        setParentCategoryName("");
      }
  }
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{(props.dataObj && props.dataObj.autoId>0)?<>Edit</>:<>New</>} Category</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Category Name</td>
                            <td>
                            <TextField onChange={event => setCategoryName(event.target.value)} value={categoryName} placeholder={'Enter category name'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Category URL</td>
                            <td>
                              <TextField onChange={event => setCategoryUrl(event.target.value)} value={categoryUrl} placeholder={'Enter category URL'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>

                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{width:'40%'}}>Channel</td>
                            <td>
                                <Select 
                                  style={{width:'100%'}}
                                  classes={{ paper: classes.paper }}
                                  labelId="select-class-labela"
                                  id="select-classa"
                                  value={channelId+"$"+channelName}									
                                  onChange={event => handleChannel(event.target.value)}
                                  variant="standard"
                                >
                                    {!channelId?<MenuItem value={"0$"} >Select Channel</MenuItem>:null} 
                                    {(props.channelList || []).map((myRow,key)=>(
                                        <MenuItem key={'mtk'+key} value={myRow.autoId+"$"+myRow.channelName} >{myRow.channelName}</MenuItem> 
                                    ))}
                                </Select>
                            </td>                            
                        </tr>

                      {(channelId && channelId>0)?  
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{width:'40%'}}>Parent Category</td>
                            <td>
                                <Select 
                                  style={{width:'100%'}}
                                  classes={{ paper: classes.paper }}
                                  labelId="select-class-labela"
                                  id="select-classa"
                                  value={parentCategoryId+"$"+parentCategoryName}									
                                  onChange={event => handleParentCategory(event.target.value)}
                                  variant="standard"
                                >
                                    <MenuItem value={"0$"} >{(parentCategoryId && parentCategoryId>0)?<>Deselect</>:<>Select</>} Category</MenuItem>
                                    {(categoryList && categoryList.length>0)?
                                      categoryList.map((myRow,key)=>(
                                        <MenuItem key={'mtk'+key} value={myRow.autoId+"$"+myRow.categoryName} >{myRow.categoryName}</MenuItem> 
                                      )):null}
                                </Select>
                            </td>                            
                        </tr>
                      :null}

                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>SEO Meta Title</td>
                            <td>
                            <TextField onChange={event => setSeoTitle(event.target.value)} value={seoTitle} placeholder={'Enter seo meta title'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>SEO Meta Description</td>
                            <td>
                            <TextField onChange={event => setSeoDescription(event.target.value)} value={seoDescription} placeholder={'Enter seo meta description'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>SEO Meta Keywords</td>
                            <td>
                            <TextField onChange={event => setSeoKeywords(event.target.value)} value={seoKeywords} placeholder={'Enter seo meta keywords'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>SEO Meta Tags</td>
                            <td>
                            <TextField onChange={event => setSeoTags(event.target.value)} value={seoTags} placeholder={'Enter seo meta tags'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Display</td>
                            <td>
                              <FormControlLabel
                                  label="Public"
                                  control={
                                    <Checkbox
                                      checked={publicDisplay}
                                      onChange={handlePublicDisplay}
                                    />
                                  }
                                />     
                                <FormControlLabel
                                  label="Home Page"
                                  control={
                                    <Checkbox
                                      checked={homeDisplay}
                                      onChange={handleHomeDisplay}
                                    />
                                  }
                                />
                                <FormControlLabel
                                  label="Header"
                                  control={
                                    <Checkbox
                                      checked={headerDisplay}
                                      onChange={handleHeaderDisplay}
                                    />
                                  }
                                />
                                <FormControlLabel
                                  label="Footer"
                                  control={
                                    <Checkbox
                                      checked={footerDisplay}
                                      onChange={handleFooterDisplay}
                                    />
                                  }
                                />
                                <FormControlLabel
                                  label="Side"
                                  control={
                                    <Checkbox
                                      checked={sideDisplay}
                                      onChange={handleSideDisplay}
                                    />
                                  }
                                />
                            </td>                            
                        </tr>

                        

                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                          {savingBtn?                
                          <LoadingButton loading loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="outlined" >Saving...</LoadingButton>
                          :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                          } 
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;